import { render, staticRenderFns } from "./SolicitacaoDetalhe.vue?vue&type=template&id=fe4a70ec"
import script from "./SolicitacaoDetalhe.vue?vue&type=script&lang=js"
export * from "./SolicitacaoDetalhe.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoDetalhe.vue?vue&type=style&index=0&id=fe4a70ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports